(function YieldMatrixCalculator($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/YieldMatrix/index', function onload()
		{
			var $form      = null,
			    $providers = $('.col[data-provider-id]');

			$form = $('form#yield-matrix-calculator');
			$form.on('change', 'input', ajaxCalculateValues);
			ajaxCalculateValues();

			function ajaxCalculateValues()
			{
				// first calculate net rate values
				$providers.each(function _calculateNetValues(i, el) {
					var $self      = $(el),
					    retail     = toFloat($self.find('[name$="[retail_price]"]').val()),
					    commission = toFloat($self.find('[name$="[commission]"]').val()),
					    discount   = toFloat($self.find('[name$="[discount]"]').val());

					$self.find('[name$="[net_rate]"]').val(retail - commission - discount);
				});

				HE.Ajax.post('/YieldMatrix/', $form.serializeArray())
				.then(function populateCalculationResults(data) {
					$providers.filter('.text-danger').removeClass('text-danger');
					$providers.filter('[data-provider-id="'+data.best_provider+'"]').addClass('text-danger');
					populateCalculatedvalues(data);
				});
			}

			function populateCalculatedvalues(data)
			{
				var $provider;

				for (const [provider_id, provider_data] of Object.entries(data.providers))
				{
					$provider = $('.col[data-provider-id="'+provider_id+'"]');

					for (const [section, section_data] of Object.entries(provider_data.yield_matrix))
					{
						for (const [line, line_data] of Object.entries(section_data))
						{
							// format values that are not already formatted from the server
							// or have special split values (dollars / percent) for display.
							// there isn't any rhyme or reason for this, just making this
							// look and behave the way it used to.
							try {
								if (line.indexOf('_pct') === -1 && line_data.value.indexOf('/') === -1) {
									line_data.value = formatDollars(line_data.value);
								}
							}
							catch (err) {
								line_data.value = formatDollars(line_data.value);
							}

							$provider.find('.output .'+section+' [data-type="'+line+'"] .value').html(line_data.value);

							if (line_data.calc) {
								$provider.find('.output .'+section+' [data-type="'+line+'"] .calculation').html(line_data.calc);
							}
						}
					}
				}
			}
		});
	});

	function toFloat(float)
	{
		var fixed_float = parseFloat(float);

		if (isNaN(fixed_float)) {
			fixed_float = parseFloat(0);
		}

		return fixed_float;
	}

	function formatDollars(dollars)
	{
		var output;

		if (dollars < 0) {
			output = '(' + accounting.formatMoney(Math.abs(dollars)) + ')';
		} else {
			output = accounting.formatMoney(dollars);
		}

		return output;
	}
}(jQuery, window.HE || {}));